module.exports = __webpack_public_path__ + "img/your-boxes.af5498c6.png";